module.exports = __webpack_public_path__ + "static/media/flask-badge.d1cb86fe.svg";